// extracted by mini-css-extract-plugin
export default {"Avatar":"styles_Avatar__dIpvi","Initial":"styles_Initial__Wls7p"};